import { useContext } from "react";

import { IntlContext, PostBillContext } from "@app/provider";
import { useGeneratedTokenizedLink } from "@app/hooks";
import { TokenizedLinkAction } from "@app/hooks/useTokenizedLinks";
import {
  GeneratedTokenizedLink,
  PostBillNotificationTemplate,
} from "@app/hooks/useGeneratedTokenizedLink";
import { LoginMethod } from "../models/postBillHeap";

const useTokenizedLinkSignUp = (): {
  redirectToTokenizedSignUp: () => Promise<void>;
  isLoading: boolean;
} => {
  const { currentLanguage } = useContext(IntlContext);
  const { patientUid, loginMethod } = useContext(PostBillContext);
  const { isLoading, getTokenizedLink } = useGeneratedTokenizedLink();

  const redirectToTokenizedSignUp = async (): Promise<void> => {
    if (!patientUid) {
      return;
    }

    const tokenizedLinkData: GeneratedTokenizedLink = {
      action: TokenizedLinkAction.TOKENIZED_LINK_SIGN_UP,
      data: {
        patientUid,
        language: currentLanguage,
        notificationType:
          loginMethod === LoginMethod.PUBLIC
            ? PostBillNotificationTemplate.POSTBILL_PUBLIC_PAYMENT_SUCCESS
            : PostBillNotificationTemplate.POSTBILL_TOKENIZED_PAYMENT_SUCCESS,
      },
      shortened: false,
    };

    const payload = await getTokenizedLink(tokenizedLinkData);

    if (payload?.link) {
      window.location.href = payload.link;
    }
  };

  return { redirectToTokenizedSignUp, isLoading };
};

export default useTokenizedLinkSignUp;
